import * as Routes from 'constants/Routes'

export default store => ({
  path: Routes.VISUALISATION,
  onEnter: (nextState, replace) => replace(Routes.PROFILE)
})
